/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when a method was called that has not been implemented
 * @export
 * @class MethodNotImplementedError
 * @extends {Error}
 */
export class MethodNotImplementedError extends Error {
  /**
   * Creates an instance of MethodNotImplementedError
   * @param {string} message The Error `message`
   * @memberof MethodNotImplementedError
   */
  constructor(message) {
    super(message);
    this.name = `MethodNotImplementedError`;
  }
}

/**
 * Called when a method was called that has not been implemented
 * @param {sting} method The name of the `method` that has not been implemented
 * @returns {never} never
 */
const throwMethodNotImplementedError = (method) => {
  throw new MethodNotImplementedError(
    stripIndent(`
    Method "${method}" has not been implemented.
    `),
  );
};

export default throwMethodNotImplementedError;
